window.oxgCartOpen = null

function create() {
  let btn = document.getElementById('oxg-cart-toggle')
  if(!btn) return
  window.oxgCartOpen = false
  btn.addEventListener('click', (e)=> {
    e.preventDefault()
    window.oxgCartOpen ? closeCart() : openCart()
  })
}

function openCart() {
  window.oxgCartOpen = true
  let container = document.getElementById('oxg-cart-flyout-container')
  let bg = document.getElementById('oxg-cart-flyout-bg')
  let wrap = document.getElementById('oxg-cart-flyout-wrap')
  if (!container || !bg || !wrap) return
  let bgClone = bg.cloneNode(true)
  bgClone.style.pointerEvents = 'all'
  bg.remove()
  container.prepend(bgClone)
  setTimeout(function() {bgClone.style.opacity = '1'}, 1);
  bgClone.addEventListener('click', ()=> {
    closeCart()
  })
  wrap.style.transform = 'translateX(0)'
  let body = document.body
  body.classList.add('cart-open')
  window.oxgBodyScrollPosY = window.oxg.page.scrollY
  body.style.overflowY = 'hidden'
  body.style.marginTop = '-' + scrollY
}

function closeCart() {
  window.oxgCartOpen = false
  let container = document.getElementById('oxg-cart-flyout-container')
  let bg = document.getElementById('oxg-cart-flyout-bg')
  let wrap = document.getElementById('oxg-cart-flyout-wrap')
  if (!container || !bg || !wrap) return
  bg.style.opacity = '0'
  bg.style.pointerEvents = 'none'
  wrap.style.transform = 'translateX(100%)'
  let body = document.body
  body.classList.remove('cart-open')
  body.style.overflowY = 'scroll'
  body.style.marginTop = '0'
  body.scroll(0, window.oxgBodyScrollPosY)
}

document.addEventListener('DOMContentLoaded', () => { 
  create();
});